import type { ReactNode } from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@london-life/ui/components/table';
import { EmptyState, LoadingState } from './states';

export type Column<Row> = { key: string; header: string; render: (row: Row) => ReactNode; className?: string };
type Props<Row> = {
  columns: Column<Row>[];
  rows: Row[] | null;
  rowKey: (row: Row) => string;
  loading?: boolean;
  empty?: string;
  onRowClick?: (row: Row) => void;
};

// every admin list: the same table, loading rows and empty message; paging and filters join it with the
// first list that needs them (Players)
export function DataTable<Row>({
  columns,
  rows,
  rowKey,
  loading,
  empty = 'Nothing here yet.',
  onRowClick,
}: Props<Row>) {
  if (loading && !rows) return <LoadingState />;
  if (!rows?.length) return <EmptyState title={empty} />;
  return (
    <div className="admin-table-wrap">
      <Table>
        <TableHeader>
          <TableRow>
            {columns.map((column) => (
              <TableHead key={column.key} className={column.className}>
                {column.header}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={rowKey(row)}
              className={onRowClick ? 'admin-row-link' : undefined}
              onClick={onRowClick ? () => onRowClick(row) : undefined}
            >
              {columns.map((column) => (
                <TableCell key={column.key} className={column.className}>
                  {column.render(row)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
